/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel finals" |
*
* @param {Finals_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_cancel = /** @type {((inputs?: Finals_CancelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_CancelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla Finali")
	return /** @type {LocalizedString} */ ("Cancel finals")
});